import isEmpty from 'validator/es/lib/isEmpty'
import isLength from 'validator/es/lib/isLength'

export const couponValidator = (value) => {
  if (!value || isEmpty(value, { ignore_whitespace: true })) {
    return 'Please enter the coupon code.'
  }

  return ''
}

export const required = (message) => (value) => value ? undefined : message

export const minLength = (min, message) => (value) =>
  isLength(String(value), { min }) ? undefined : message

export const maxLength = (max, message) => (value) =>
  isLength(String(value), { max }) ? undefined : message

export const compose =
  (...validators) =>
  (value) =>
    validators.reduce(
      (error, validator) => error || validator(value),
      undefined
    )
